import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { saveLoginInfo } from "../../../../features/mobile/commonSlice";

const GoogleCallback = () => {
    const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Get JWT token and user info from URL query parameters
    const token = searchParams.get("token");
    const userId = searchParams.get("userId");
    const email = searchParams.get("email");
    const nickName = searchParams.get("nickName");
    const photo = searchParams.get("photo");
    const characterPhoto = searchParams.get("characterPhoto");
    const registrationStep = searchParams.get("registrationStep");
    const error = searchParams.get("error");

    if (error) {
      console.error("Google OAuth error:", error);
      alert("Google login failed" + ": " + error);
      navigate('/sign');
      return;
    }

    if (token && userId) {
      // Store JWT token
      localStorage.setItem('accessToken', token);

      // Store Firebase token if available
      const firebaseToken = window.sessionStorage.getItem("token");

      // Save user info to Redux store
      dispatch(
        saveLoginInfo({
          userId: userId,
          nickName: nickName || email?.split('@')[0],
          email: email,
          photo: photo,
          characterPhoto: characterPhoto,
          existPass: true,
        })
      );

      // Check if user needs to complete signup (nickname/character)
      if (registrationStep === 'terms_agreed') {
        // User has agreed to terms but hasn't completed nickname/character
        navigate(`/auth/google-signup?resumeStep=2&userId=${userId}&email=${email}&nickName=${encodeURIComponent(nickName || '')}&photo=${encodeURIComponent(photo || '')}`);
      } else {
        // Registration complete, navigate to home
        navigate('/home');
      }
    } else {
      console.error("Missing token or userId in callback");
      alert("An error occurred. Please try again.");
      navigate('/sign');
    }
  }, [dispatch, navigate, searchParams]);

  return (
    <div className="flex items-center justify-center h-screen">
      <img src="/images/mobile/splash.svg" alt={"Loading..."} />
      <p className="mt-4 text-gray-600">{"Processing..."}</p>
    </div>
  );
};

export default GoogleCallback;
